import React from "react";
import { Warning } from "@culturehq/components";

import { Trans } from "app/utils";

const EmptyGallery = () => (
  <Warning><Trans>Be the first to add a photo!</Trans></Warning>
);

export default EmptyGallery;
